// extracted by mini-css-extract-plugin
export default {"wrapper":"ClientActionsTab_wrapper__p-H4b"};